import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import {AppStartupService, AppStartupServiceFactory} from "./core/services/app-start-up.service";
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RedirectComponent } from './features/redirect/redirect.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionExpiredComponent } from './features/session-expired/session-expired.component';
import {SessionExpiredModule} from "@doa/features/session-expired/session-expired.module";
@NgModule({
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [AppStartupService,
    { provide: APP_INITIALIZER, useFactory: AppStartupServiceFactory, deps: [AppStartupService], multi: true },
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {provide : HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}],
  bootstrap: [AppComponent]
})
export class AppModule { }
